module.exports = __webpack_public_path__ + "static/img/zhizao_hangye.48176428.png";